/**
 * Scroll-triggered reveal (IntersectionObserver) for .r elements
 */
(function () {
  const root = document.querySelector('[data-sdl-landing]');
  if (!root) return;
  const obs = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('in');
      });
    },
    { threshold: 0.06 }
  );
  root.querySelectorAll('.r').forEach(function (el) {
    obs.observe(el);
  });
})();

/**
 * Native FSDL invite waitlist forms (sections/fsdl_invite.liquid → data-fsdl-native-waitlist)
 */
(function () {
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.getAttribute || !form.hasAttribute('data-fsdl-native-waitlist')) return;
      e.preventDefault();
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        Array.prototype.slice.call(form.querySelectorAll('input')).forEach(function (inp) {
          if (!inp.checkValidity()) inp.classList.add('user-invalid');
          else inp.classList.remove('user-invalid');
        });
        form.reportValidity();
        return;
      }
      Array.prototype.slice.call(form.querySelectorAll('.user-invalid')).forEach(function (inp) {
        inp.classList.remove('user-invalid');
      });
      form.style.display = 'none';
      var sid = form.getAttribute('data-success-id');
      if (!sid) return;
      var box = document.getElementById(sid);
      if (box) box.hidden = false;
    },
    true
  );
  document.addEventListener('input', function (e) {
    var el = e.target;
    var form = el && el.closest && el.closest('[data-fsdl-native-waitlist]');
    if (form && el instanceof HTMLInputElement) el.classList.remove('user-invalid');
  });
})();
